const prefix = 'Settings/Menu'

export const ITEMS_ADD = `${prefix}/ITEMS_ADD`
